import React, { Component, Fragment } from "react";

//import compoents
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import ReactDatatable from '@ashvin27/react-datatable';

//import Actions
import { perpetualMaintencance } from '../../actions/reportActions'

//Downloads
import { jsPDF } from "jspdf";
import 'jspdf-autotable';
import { CSVLink } from "react-csv";

//import lib
import { momentFormat } from '../../lib/dateTimeHelper'

class MaintenanceRate extends Component {
    constructor(props) {
        super(props);

        this.columns = [
            {
                key: "createdAt",
                text: "Date",
                className: "Date",
                align: "left",
                sortable: true,
                width: 200,
                cell: record => {
                    return momentFormat(record.createdAt, "DD-MM-YYYY HH:mm")
                }

            },
            {
                key: "userCode",
                text: "User Code",
                className: "Date",
                align: "left",
                sortable: true,
                width: 200,
            },
            {
                key: "pairName",
                text: "Contract",
                className: "Amount",
                align: "left",
                sortable: true,
                width: 200,
            },
            {
                key: "price",
                text: "Price",
                className: "name",
                align: "left",
                sortable: true,
            },
            {
                key: "quantity",
                text: "Quantity",
                className: "name",
                align: "left",
                sortable: true,
            },
            {
                key: "feePaid",
                text: "Fee Paid",
                className: "name",
                align: "left",
                sortable: true,
            },
            {
                key: "feeRate",
                text: "Fee Rate",
                className: "name",
                align: "left",
                sortable: true,
            }
        ];

        this.config = {
            page_size: 10,
            length_menu: [10, 20, 50],
            filename: "Order",
            no_data_text: 'No Email Templates found!',
            language: {
                length_menu: "Show _MENU_ result per page",
                filter: "Filter in records...",
                info: "Showing _START_ to _END_ of _TOTAL_ records",
                pagination: {
                    first: "First",
                    previous: "Previous",
                    next: "Next",
                    last: "Last"
                }
            },
            show_length_menu: false,
            show_filter: true,
            show_pagination: true,
            show_info: true,
        };
        this.state = {
            records: [],
            loader: false,
            page: 1,
            limit: 10,
            count: 0,
            document: []
        };
        this.handlePagination = this.handlePagination.bind(this);
        this.exportPDF = this.exportPDF.bind(this);

    }
    componentDidMount() {
        const { page, limit } = this.state;
        let reqData = {
            page,
            limit
        }
        this.getPerpetualOrder(reqData)
    };

    handlePagination(index) {
        let reqData = {
            page: index.page_number,
            limit: index.page_size,
            search: index.filter_value
        }
        this.getPerpetualOrder(reqData);
        this.setState({ page: index.page_number, limit: index.page_size, search: index.filter_value })
    }


    async getPerpetualOrder(reqData) {
        try {
            let arr = []
            this.setState({ 'loader': true })
            const { status, loading, result } = await perpetualMaintencance(reqData);
            this.setState({ 'loader': loading })
            if (status == 'success') {
                this.setState({ "count": result.count, 'records': result.data })
                result && result.data && result.data.length > 0 && result.data.map(item => {
                    return (
                        arr.push({
                            'Date': momentFormat(item.createdAt, "DD-MM-YYYY HH:mm"),
                            'user Code': item.userCode,
                            'Contract': item.pairName,
                            'Price': item.price,
                            'Quantity': item.quantity,
                            'Fee Paid': item.feePaid,
                            'Fee Rate': item.feeRate,
                        })
                    )
                })
                this.setState({ 'document': arr })
            }
        } catch (err) { }
    }


    async exportPDF() {
        const { records } = this.state

        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "landscape"; // portrait or landscape

        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(13);

        const title = "perpetualMaintenance";
        const headers = [
            [
                'Date',
                'user Code',
                'Contract',
                'Price',
                'Quantity',
                'Fee Paid',
                'Fee Rate'
            ],
        ];

        const data =
            records.length > 0 &&
            records.map((elt) => [
                momentFormat(elt.createdAt, "DD-MM-YYYY HH:mm"),
                elt.userCode,
                elt.pairName,
                elt.price,
                elt.quantity,
                elt.feePaid,
                elt.feeRate
            ]);

        let content = {
            startY: 50,
            head: headers,
            body: data,
        };

        doc.text(title, marginLeft, 40);
        doc.autoTable(content);
        doc.save("perpetualMaintenance.pdf");
    }


    render() {

        const { records, count, loader, document } = this.state

        return (
            <div>
                <Navbar />
                <div className="d-flex" id="wrapper">
                    <Sidebar />
                    <div id="page-content-wrapper">
                        <div className="container-fluid">
                            <h3 className="mt-2 text-secondary">Perpetual Maintencance Rate</h3>

                            {records && records.length > 0 ? (
                                <button onClick={this.exportPDF} className='btn btn-info' style={{ width: '118px', height: '35px', fontSize: '13px' }}>Download(PDF)</button>
                            ) : (
                                ""
                            )}

                            {records && records.length > 0 ? (
                                <CSVLink
                                    data={document}
                                    filename={"perpetualMaintenance.csv"}
                                    className="btn btnTrade1 py-4"
                                >
                                    <button className='btn btn-info' style={{ width: '118px', height: '35px', fontSize: '13px' }}>Download(CSV)</button>
                                </CSVLink>
                            ) : (
                                ""
                            )}

                            {records && records.length > 0 ? (
                                <CSVLink
                                    data={document}
                                    filename={"perpetualMaintenance.xls"}

                                >
                                    <button className='btn btn-info' style={{ width: '118px', height: '35px', fontSize: '13px' }}>Download(XLS)</button>
                                </CSVLink>
                            ) : (
                                ""
                            )}
                            <ReactDatatable
                                config={this.config}
                                records={this.state.records}
                                columns={this.columns}
                                total_record={count}
                                dynamic={true}
                                loading={loader}
                                onChange={this.handlePagination}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default MaintenanceRate;
